import { ChartPie, SlidersHorizontal } from "lucide-react";

import { cn } from "@/lib/utils";
import type { PageId } from "@/lib/nav";
import { useNavigate } from "@/components/app-shell";

const TABS: { id: PageId; label: string; icon: React.ComponentType<{ className?: string }> }[] = [
  { id: "finance-dashboard", label: "Dashboard", icon: ChartPie },
  { id: "finance-config", label: "Configuration", icon: SlidersHorizontal },
];

/**
 * Switches between the Finance sub-views. The sidebar shows them as a group on
 * desktop; this keeps them reachable on mobile, where the bottom bar only has
 * room for the group itself.
 */
export function FinanceTabs({ active }: { active: PageId }) {
  const navigate = useNavigate();

  return (
    <div className="inline-flex rounded-lg border bg-background p-1">
      {TABS.map((tab) => {
        const Icon = tab.icon;
        const isActive = tab.id === active;
        return (
          <button
            key={tab.id}
            onClick={() => navigate(tab.id)}
            aria-current={isActive ? "page" : undefined}
            className={cn(
              "flex items-center gap-2 rounded-md px-3 py-1.5 text-sm font-medium transition-colors",
              isActive ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:bg-accent",
            )}
          >
            <Icon className="size-4" />
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
